export default [
  {
    path: '/config',
    name: 'config',
    component: () => import('../../views/config/config.vue'),
    children: [
      {
        path: 'mobile-tv',
        name: 'mobile-config',
        component: () => import('../../views/config/mobile/mobile-config.vue'),
        meta: {
          pageTitle: 'Mobile & TV Configuration',
          breadcrumbs: ['Configurations', 'Mobile & TV'],
        },
        children: [
          {
            path: '',
            name: 'mobile-config-list',
            component: () => import('../../views/config/mobile/list.vue'),
          },
          {
            path: 'create',
            name: 'mobile-config-create',
            component: () => import('../../views/config/mobile/create.vue')
          },
          {
            path: ':id/edit',
            name: 'mobile-config-edit',
            component: () => import('../../views/config/mobile/edit.vue')
          },
        ]
      },
      {
        path: 'web',
        name: 'web-config',
        component: () => import('../../views/config/web/web-config.vue'),
        meta: {
          pageTitle: 'Web Configuration',
          breadcrumbs: ['Configurations', 'Web'],
        }
      }
    ]
  }
]
